import { render, staticRenderFns } from "./TradeRoutePanel.vue?vue&type=template&id=043d0b24&"
import script from "./TradeRoutePanel.vue?vue&type=script&lang=js&"
export * from "./TradeRoutePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports